import { useTranslation as useI18nTranslation } from 'react-i18next';
export var useTranslation = function () {
    var t = useI18nTranslation().t;
    return { t: t };
};
